import { useEffect, useState } from 'react';
import {HsePage} from "../../core/controllers/HsePageScraperController";

export default function useGetHsePage(id: string, lang?: string, url?: string): any {
    const [hsePage, setHsePage] = useState<any>([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState<any>();
    useEffect(() => {
        setLoading(true);
        if (id) {
            (async () => {
                try {
                    let resp: any;
                    let connectionString = url || ('https://design.hse.ru/api/pages/'+ id);
                    // let connectionString = 'http://design.deva:3002/api/pages/'+ id;
                    if (lang) {
                        connectionString+= '?lang='+ lang;
                    }
                    await fetch(connectionString)
                    .then((response) => {
                        response.json().then((data) => {
                            resp = data;
                            setHsePage(resp as HsePage);
                            setLoading(false);
                            setError(undefined);
                        });
                    })
                    .catch(console.error);
                } catch (e) {
                    setLoading(false);
                    setError(e);
                    setHsePage([]);
                }
            })();
        }
    }, [id, lang]);
    return [hsePage, loading, error];
}
import { useEffect, useState } from 'react';
import {HsePage} from "../../core/controllers/HsePageScraperController";

export default function useGetHsePage(id: string, lang?: string, url?: string): any {
    const [hsePage, setHsePage] = useState<any>([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState<any>();
    useEffect(() => {
        setLoading(true);
        if (id) {
            (async () => {
                try {
                    let resp: any;
                    let connectionString = url || ('https://design.hse.ru/api/pages/'+ id);
                    // let connectionString = 'http://design.deva:3002/api/pages/'+ id;
                    if (lang) {
                        connectionString+= '?lang='+ lang;
                    }
                    await fetch(connectionString)
                    .then((response) => {
                        response.json().then((data) => {
                            resp = data;
                            setHsePage(resp as HsePage);
                            setLoading(false);
                            setError(undefined);
                        });
                    })
                    .catch(console.error);
                } catch (e) {
                    setLoading(false);
                    setError(e);
                    setHsePage([]);
                }
            })();
        }
    }, [id, lang]);
    return [hsePage, loading, error];
}
